var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.dynamicComponent,_vm._b({tag:"component",staticClass:"pc-progress",on:{"submit":function($event){return _vm.formSubmit($event)},"next":function($event){return _vm.gotoNextPage()},"back":_vm.delayedGoBack}},'component',{..._vm.componentData,'pageConfig': _vm.getPageConfigByName(this.page) },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }